import React, { Component } from 'react'
import HeaderUi from '../../presentational/Layout/Header.component'

class HeaderPage extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <HeaderUi
                profileSettingHandler={this.profileSettingHandler.bind(this)}
                mainMenuHandler={this.mainMenuHandler.bind(this)}
                globalSearch={this.globalSearch.bind(this)}
                activeClassName={this.props.activeClassName}
                showPage={this.showPage.bind(this)}
                globalPageHandler={this.globalPageHandler.bind(this)}
                globalSearching={this.props.globalSearching}
            />
        )
    }

    globalPageHandler(e, val) {
        this.props.globalPageHandler(e, val)
    }

    showPage(e, title) {
        this.props.getPageTitle(e, title)
    }

    AdvanceSearchPageHandler() {
        this.props.AdvanceSearchPageHandler()
    }

    globalSearch(e) {
        this.props.globalSearchHandler(e)
    }

    mainMenuHandler() {
        this.props.mainMenuHandler()
    }

    dashboardSettingHandler() {
        this.props.dashboardSettingHandler()
    }

    profileSettingHandler(type) {
        this.props.profileSettingHandler(type)
    }
}

export default HeaderPage;